import { useGetOne } from 'react-admin';

export function useCancellations() {
  return useGetOne('', { id: 'cancellation-assignments' });
}
